import dynamic from "next/dynamic";
import React from "react";

const Item = dynamic(() => import("./Item"));

export const PopularSearches = () => {
  return (
    <div className="w-full">
      <div className="border-b border-white">
        <h2 className="text-white">Popular Searches</h2>
      </div>
      <div className="text-white pt-2 flex flex-col gap-1">
        <Item
          search="/city/Mississauga?city=Mississauga&styles=&styles=Backsplit+3&page=1"
          title="Backsplit 3 for Sale"
        />
        <Item
          search="/city/Mississauga?city=Mississauga&styles=&styles=Backsplit+4&page=1"
          title="Backsplit 4 for Sale"
        />
        <Item
          search="/city/Mississauga?city=Mississauga&styles=&styles=Backsplit+5&page=1"
          title="Backsplit 5 for Sale"
        />
        <Item
          search="/city/Mississauga?city=Mississauga&styles=&styles=Bungaloft&page=1"
          title="Bungaloft for Sale"
        />
        <Item
          search="/city/Mississauga?city=Mississauga&styles=&styles=Backsplit+5&page=1"
          title="Backsplit 5 for Sale"
        />
        <Item
          search="/city/Mississauga?city=Mississauga&styles=&styles=Bungalow-Raised&page=1"
          title="Bungalow-Raised for sale "
        />
        <Item
          search="/city/Mississauga?city=Mississauga&styles=&styles=Sidesplit+3&page=1"
          title="Sidesplit 3 for Sale"
        />
        <Item
          search="/city/Mississauga?city=Mississauga&styles=&styles=Sidesplit+4&page=1"
          title="Sidesplit 4 for Sale"
        />
        <Item
          search="/city/Mississauga?city=Mississauga&styles=&styles=Sidesplit+5&page=1"
          title="Sidesplit 5 for Sale"
        />
      </div>
    </div>
  );
};
export default PopularSearches;
